/*
 * Copyright Camunda Services GmbH and/or licensed to Camunda Services GmbH under
 * one or more contributor license agreements. See the NOTICE file distributed
 * with this work for additional information regarding copyright ownership.
 * Licensed under the Camunda License 1.0. You may not use this file
 * except in compliance with the Camunda License 1.0.
 */

import { Tooltip } from 'primitives';

import * as Styled from './VersionDescription.styled';

export function VersionDescription({ description, maxLength = 60 }) {
  if (!description) {
    return null;
  }

  const descriptionElement = (
    <Styled.VersionDescription data-test="version-description">{description}</Styled.VersionDescription>
  );

  if (description.length > maxLength) {
    return (
      <Tooltip data-test="version-description-tooltip" title={description}>
        {descriptionElement}
      </Tooltip>
    );
  }

  return descriptionElement;
}
